import { cn } from "@/lib/cn";

const TONES = {
  neutral: "bg-secondary text-muted-foreground border-border",
  success: "text-status-paid border-status-paid/30 bg-status-paid/10",
  muted: "text-status-superseded border-status-superseded/30 bg-status-superseded/10",
  accent: "text-primary border-primary/30 bg-primary/10",
  info: "text-status-sent border-status-sent/30 bg-status-sent/10",
};

export function Pill({ tone = "neutral", className, children, ...props }) {
  return (
    <span
      className={cn(
        "inline-flex items-center whitespace-nowrap rounded-full border px-2.5 py-0.5 text-xs font-medium font-sans",
        TONES[tone],
        className
      )}
      {...props}
    >
      {children}
    </span>
  );
}
